import { render, staticRenderFns } from "./AppNotification.vue?vue&type=template&id=0d04464e"
import script from "./AppNotification.vue?vue&type=script&lang=js"
export * from "./AppNotification.vue?vue&type=script&lang=js"
import style0 from "./AppNotification.vue?vue&type=style&index=0&id=0d04464e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports